// Angular
import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef, Inject, ViewChild, ViewRef, ElementRef, HostListener, Input } from '@angular/core';
// NGRX
// Service
//Models
import { DatePipe } from '@angular/common';
import { FunctionPublic } from 'app/views/pages/nfc/dung-chung/__function/common_function';


@Component({
	selector: 'kt-in-nhap-kho-tu-ncc-171123',
	templateUrl: './in-nhap-kho-tu-ncc-171123.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})


export class NhapKhoTuNcc171123PrintComponent implements OnInit {

	@Input() masterData: any;
	@Input() detailData: any[];
	constructor(
		private datePipe: DatePipe) {};
		
	/**
	 * On init
	 */
	ngOnInit() {
		console.log(this.detailData)
		this.detailData = this.detailData.filter(x => x.TrangThaiChiTiet == false)
	}
	
	get_date_nhap_kho(){
		var date = new Date(this.masterData.NgayChuyen);
		return "Ngày "+("0" + date.getDate().toString()).slice(-2)+ "/"+ ("0" + (date.getMonth() + 1).toString()).slice(-2) + "/"+ date.getFullYear(); 
	}
	FormatDatetime(datetime) {
		return this.datePipe.transform(datetime, 'dd/MM/yyyy');
	}
	sum_so_luong(){
		// ;
		return this.detailData.length > 0 ? this.detailData.map(x => Number(x.KhoiLuongQuyDoi)).reduce((a, b) => a + b) : 0;
	}
	sum_so_luong_ke_hoach(){
		// ;
		return this.detailData.length > 0 ? this.detailData.map(x => Number(x.Soluongkehoach)).reduce((a, b) => a + b) : 0;
	}
	getLyDo(){
		if(this.masterData.LyDo){
			return this.masterData.LyDo;
		}
		else if(this.detailData.find(x => x.IdDnCtCk != null)){
			const filteredList = this.detailData.filter(x => x.IdDnCtCk !== null);
			// Extract the SoPhieuDeNghi from the filtered list
			const SoPhieuDeNghiList = filteredList.map(x => x.SoPhieuDeNghi);
			return "Theo đề nghị chuyển kho số "+ SoPhieuDeNghiList;
		}
	}
	get_date(){
		var date = new Date();
		return "Ngày "+("0" + date.getDate().toString()).slice(-2)+ "/"+ ("0" + (date.getMonth() + 1).toString()).slice(-2) + "/"+ date.getFullYear(); 
	}
	f_convertDate(p_Val: any) {
		if(p_Val == null || p_Val == undefined || p_Val == '') return '';
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
	f_number(item: any = "0.00"){
		return FunctionPublic.F_NUMBER(item);
	}
	ChungTuKemTheo(item){
		if(item){
			return this.masterData.ChungTuKemTheo?'none':''
		}
		return this.masterData.ChungTuKemTheo?'':'none'
	}
}
